'use client'

import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { handleCMS } from "@/(front-desk)/store"
import { categoryList } from "./page"
import { Pattern1 } from "@/(front-desk)/utils/patterns"
import { reportError } from "@/(front-desk)/utils/functions"
import Transition from "@/(front-desk)/components/Transition"
import classNames from "classnames"
import Link from "next/link"
import axios from "axios"
import dayjs from "dayjs"

export default function Download(props) {

    const dispatch = useDispatch()
    const CMS = useSelector((state) => state.CMS)
    const category = props.category
    const downloadList = {
        'procedure': {
            apiUrl: '/api/v1/cms/zh_hant/posts?category=cms.downloads.regulations',
            data: CMS.downloadProcedure,
            func: 'setDownloadProcedure'
        },
        'handbook': {
            apiUrl: '/api/v1/cms/zh_hant/posts?category=cms.downloads.manuals',
            data: CMS.downloadHandbook,
            func: 'setDownloadHandbook'
        },
        'winners': {
            apiUrl: '/api/v1/cms/zh_hant/posts?category=cms.downloads.award_list',
            data: CMS.downloadWinners,
            func: 'setDownloadWinners'
        },
        'medal': {
            apiUrl: '/api/v1/cms/zh_hant/posts?category=cms.downloads.award_badges',
            data: CMS.downloadMedal,
            func: 'setDownloadMedal'
        }
    }


    useEffect(() => {
        if (!downloadList[category].data) {
            axios.get(downloadList[category].apiUrl)
            .then((res) => {
                // console.log('download success: ', res.data.body.results)
                dispatch(handleCMS.actions[downloadList[category].func](res.data.body.results))
            })
            .catch((err) => {
                // console.log(err.config?.url, err)
                reportError(err, true)
            })
        }
    }, [])

    return (
        <>
        <title>下載專區 - 放視大賞</title>
        <main className="download">
            <div className="page-banner">
                <div className="page-banner-content flex justify-between items-center">
                    <div>
                        <h1 className="title">Downloads</h1>
                        <h2 className="sub-title">下載專區</h2>
                    </div>
                    <Pattern1 className="fill-main w-[4.5rem]" />
                </div>
            </div>
            <div id="main" className="download-content py-6 sm:py-20">
                <div className="category-group">
                    <div className="scroll">
                        { Object.keys(categoryList).map((e) => {
                            const categoryClass = classNames('btn', {
                                'active': category === e
                            })
                            const item = 
                                <Link
                                    key={`category-${e}`}
                                    className={categoryClass}
                                    href={`/download/${e}`}
                                >{categoryList[e]}</Link>
                            return item
                        })}
                    </div>
                </div>
                <div className="bottom-area">
                    <Transition transitionKey={category}>
                        { downloadList[category].data?.length === 0 &&
                            <div className="py-12 text-black-500 text-center">此分類目前尚無資料</div>
                        }
                        { downloadList[category].data && downloadList[category].data.map((e, index) => {
                            const item = 
                                <div key={`item-${index}`} className="item">
                                    <div className="info-area">
                                        <div
                                            className={classNames('name', {
                                                'new': e.display_start_time && dayjs().diff(dayjs(e.display_start_time), 'day') < 7
                                            })}
                                        >{e.contents.subject}</div>
                                        { e.display_start_time &&
                                            <div className="time">{dayjs(e.display_start_time).format('YYYY.MM.DD')}</div>
                                        }
                                    </div>
                                    <div className="flex gap-2">
                                        { e.attachments.map((linkInfo, index) => {
                                            let link
                                            if (linkInfo.link) {
                                                link = 
                                                    <a
                                                        key={`link-${e.contents.subject}-${index}`}
                                                        className="btn btn-outline-white h-fit py-1 px-4 font-normal whitespace-nowrap"
                                                        href={linkInfo.link}
                                                        target="_blank"
                                                        title={`另開新視窗前往-${linkInfo.download_filename}`}
                                                    >{linkInfo.display_name}</a>
                                            }
                                            if (linkInfo.media) {
                                                link = 
                                                    <a
                                                        key={`link-${e.contents.subject}-${index}`}
                                                        className="btn btn-outline-white h-fit py-1 px-4 font-normal whitespace-nowrap"
                                                        href={linkInfo.media.file}
                                                        download={linkInfo.download_filename}
                                                        target="_blank"
                                                        title={`另開新視窗前往下載檔案-${linkInfo.download_filename}`}
                                                    >{linkInfo.display_name}</a>
                                            }
                                            return link
                                        })}
                                    </div>
                                </div>
                            return item
                        })}
                    </Transition>
                </div>
            </div>
        </main>
        </>
    )
}